import React from "react";
import AOS from "aos";
// import "aos/dist/aos.css";

import {
	Wrapper,
	ContentWrapper,
	Content,
	ContentImg,
	ContentWord,
} from "./KokaMenu.Styles";

const KokaMenu = ({ dataMenu, label, id }) => {
	AOS.init();
	return (
		<Wrapper>
			<h1 id={id}>{label}</h1>
			<ContentWrapper menu={dataMenu}>
				{dataMenu.map(menu => {
					return (
						<Content
							key={menu.menuId}
							menu={menu}
							data-aos="fade-up"
							data-aos-duration="2000"
						>
							<ContentImg
								src={menu.menuImage.default}
								effect="blur"
								width="100%"
								height="60%"
								alt={menu.menuId}
							/>
							<ContentWord>
								<span className="menu-name">
									{menu.menuName}
								</span>
								<p className="menu-price">{menu.menuPrice}</p>
								{menu.menuAddition.length !== 0 ? (
									<>
										<ul className="addition">
											{menu.menuAddition.map(data => {
												return (
													<li key={data}>{data}</li>
												);
											})}
										</ul>
									</>
								) : (
									""
								)}
							</ContentWord>
						</Content>
					);
				})}
			</ContentWrapper>
		</Wrapper>
	);
};

export default KokaMenu;
